import { Controller } from "@hotwired/stimulus";

// One Stripe Element flow for both intents: mode "payment" confirms the pay
// page's stored PaymentIntent; mode "setup" fetches a fresh SetupIntent for
// card capture. The webhook persists the outcome either way.
export default class extends Controller {
  static targets = ["element", "errors", "button"];
  static values = {
    publicKey: String,
    mode: String,
    clientSecret: String,
    setupIntentUrl: String,
    returnUrl: String,
  };

  async connect() {
    if (typeof Stripe === "undefined") return;

    this.stripe = Stripe(this.publicKeyValue);
    const clientSecret = this.clientSecretValue || (await this.fetchClientSecret());
    if (!clientSecret) return;

    this.elements = this.stripe.elements({ clientSecret });
    this.elements.create("payment").mount(this.elementTarget);
  }

  async submit(event) {
    event.preventDefault();
    this.buttonTarget.setAttribute("disabled", true);
    const confirm = this.modeValue === "setup" ? "confirmSetup" : "confirmPayment";
    const { error } = await this.stripe[confirm]({
      elements: this.elements,
      confirmParams: { return_url: this.returnUrlValue },
    });
    if (error) {
      this.errorsTarget.textContent = error.message;
      this.buttonTarget.removeAttribute("disabled");
    }
  }

  async fetchClientSecret() {
    const response = await fetch(this.setupIntentUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
        Accept: "application/json",
      },
    });
    if (!response.ok) {
      this.errorsTarget.textContent = "Card entry is unavailable for this account.";
      return null;
    }
    const { client_secret: clientSecret } = await response.json();
    return clientSecret;
  }
}
